import React, { useEffect, useRef } from 'react';
import { gsap } from '../../lib/gsap';
import { achievementData } from '../../data/achievementData';
import './Achievement.css';

function Achievement() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.ach-title', {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '.ach-title',
          start: 'top 85%',
        },
      });

      gsap.from('.ach-bio', {
        opacity: 0,
        y: 20,
        duration: 0.7,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '.ach-bio',
          start: 'top 85%',
        },
      });

      const items = gsap.utils.toArray('.ach-item');
      if (items.length) {
        gsap.from(items, {
          y: 24,
          opacity: 0,
          stagger: 0.12,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.ach-list',
            start: 'top 82%',
          },
        });
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="ach-section" id="achievement" ref={sectionRef}>
      <div className="ach-inner">
        <h2 className="section-title ach-title">Certs & credentials</h2>
        <p className="ach-bio">{achievementData.bio}</p>

        <div className="ach-list">
          {achievementData.achievements.map((item) => (
            <div key={item.id} className="ach-item">
              <div className="ach-years">
                {item.date} <span className="ach-field">{item.field}</span>
              </div>
              <div className="ach-content">
                <h3 className="ach-title-text">{item.title}</h3>
                <p className="ach-details">{item.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Achievement;
